import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'

export const REQUEST_PROVIDERS_EMPTY_DATA = {
  contractors: EMPTY_LIST,
  permissions: EMPTY_OBJECT,
  workers: EMPTY_LIST,
}
